import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 44 44"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "44",
      height: "44",
      fill: "#fc3f1d",
      rx: "22"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M25.244 12.32h-2.227c-3.817 0-5.725 1.91-5.725 4.772 0 3.18 1.272 4.771 4.135 6.68l2.226 1.59-6.361 9.86h-5.09l6.044-8.906c-3.499-2.545-5.407-4.771-5.407-8.906 0-5.09 3.499-8.588 10.178-8.588h6.68v26.4h-4.453V12.321Z"
    }, null, -1)
  ])))
}
export default { render: render }